module.exports = __webpack_public_path__ + "img/lopez_orozco.f46b5f0c.png";